import { SWReactIcons } from "@similarweb/icons";
import { TableCompareTitleWrapper } from "./styledComponents";
import { i18nFilter } from "app/filters/i18nFilter";

// Replaces table-compare-title.html
export const TableCompareTitleTemplate = (props) => {
    const { widgetInstance } = props;
    const { viewData, viewOptions, apiParams } = widgetInstance;
    const { showTitle, showTitleTooltip } = viewOptions;
    const { tooltip } = viewData;
    const title = widgetInstance.getWidgetMetricConfig()?.title;
    const translatedTitle = i18nFilter()(title, { site: apiParams?.keys });
    return (
        <>
            {showTitle ? (
                <TableCompareTitleWrapper className="swHeader-title">
                    <span>{translatedTitle}</span>
                    {showTitleTooltip ? (
                        <span
                            className="swHeader-tooltip scss-tooltip scss-tooltip--s"
                            data-scss-tooltip={tooltip}
                        >
                            <SWReactIcons
                                className="info-icon-widget-header"
                                iconName="info"
                            />
                        </span>
                    ) : null}
                </TableCompareTitleWrapper>
            ) : null}
        </>
    );
};
